<script lang="ts">
    import { _ } from "svelte-i18n";
    import { ModalHook } from "../shared/modals/ModalHook";
    import { appManager } from "../AppManager";
    import { FeatherCopy, MatrixTransposeIcon } from "@anyways-open/common-svgs";
    import type { MatrixData } from "../api/projects/data/matrix/MatrixData";
    
    let hook: ModalHook<MatrixData, "none" | "copy" | "transpose"> = new ModalHook<MatrixData, "none" | "copy" | "transpose">();
    appManager.ModalHooks.OdCopyModal = hook;
    
    let open = false;

    // hook events.
    hook.on("open", () => {
        open = true;
    });
    hook.on("close", () => {
        open = false;
    });

    const close = () => {
        hook.close("none");
    };

    const onChooseCopy = () => {
        hook.close("copy");
    };

    const onChooseTranspose = () => {
        hook.close("transpose");
    };

    const todo = () => {

    };
</script>

{#if open}
    <div class="modal show" style="display: block;">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title h4">{$_("impact.scenario.matrixCopyModal.title")}</div>
                    <button
                        type="button"
                        class="btn-close btn-lg btn-close-lg"
                        aria-label="Close"
                        on:click={() => close()} />
                </div>
                <div class="modal-body p-0">
                    <div class="container p-0 ">
                        <div class="row g-0">
                            <div
                                class="col-12 col-md-6 p-2 pointer" on:click={() => onChooseCopy()} on:keypress={() => todo()}>
                                <div
                                    class="card shadow-light-lg mb-6 mb-md-0 h-100">
                                    <FeatherCopy class="card-img-top" style="padding: 50px;"/>
                                    <div class="position-relative">
                                        <div
                                            class="shape shape-bottom shape-fluid-x svg-shim text-white">
                                            <svg
                                                viewBox="0 0 2880 48"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                ><path
                                                    d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z"
                                                    fill="currentColor" /></svg>
                                        </div>
                                    </div>
                                    <div class="card-body position-relative">
                                        <h3> {$_("impact.scenario.matrixCopyModal.copy")}</h3>
                                        <p class="text-muted">
                                            {$_("impact.scenario.matrixCopyModal.copyExplain")}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-12 col-md-6 p-2 pointer"  on:click={() => onChooseTranspose()} on:keypress={() => todo()}>
                                <div
                                    class="card shadow-light-lg mb-6 mb-md-0 h-100">
                                    <MatrixTransposeIcon class="card-img-top" style="padding: 10px;"/>

                                    <div class="position-relative">
                                        <div
                                            class="shape shape-bottom shape-fluid-x svg-shim text-white">
                                            <svg
                                                viewBox="0 0 2880 48"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                ><path
                                                    d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z"
                                                    fill="currentColor" /></svg>
                                        </div>
                                    </div>
                                    <div class="card-body position-relative">
                                        <h3> {$_("impact.scenario.matrixCopyModal.transpose")}</h3>
                                        <p class="text-muted">
                                            {$_("impact.scenario.matrixCopyModal.transposeExplain")}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}

<style>
    .pointer {cursor: pointer;}

    .modal {
        display: block;
    }

    .modal-lg {
        max-width: 600px;
    }
</style>
